import create from 'zustand';

interface FloatingChatState {
  mode: 'spaces' | 'ai';
  expanded: boolean;
  visible: boolean;
  setMode: (mode: 'spaces' | 'ai') => void;
  setExpanded: (expanded: boolean) => void;
  setVisible: (visible: boolean) => void;
}

export const useFloatingChatStore = create<FloatingChatState>((set) => ({
  mode: 'spaces',
  expanded: false,
  visible: true,
  setMode: (mode: 'spaces' | 'ai') => set({ mode }),
  setExpanded: (expanded: boolean) => set({ expanded }),
  setVisible: (visible: boolean) => set({ visible }),
}));
